import React from 'react';
const { m } = require('framer-motion');
import PropTypes from 'prop-types';
import { Box, Typography, Card, CardMedia } from '@mui/material';
import Iconify from '../Iconify';

function EventDetails({
  event: {
    event: { id, about, banner },
  },
}) {
  return (
    <Box sx={{ marginTop: '24px', marginBottom: '24px' }}>
      <Box
        sx={{
          paddingTop: '8px',
          paddingBottom: '8px',
        }}
      >
        <Typography sx={{ flex: 1 }} variant="h6" component="div">
          Detalles del evento
        </Typography>
      </Box>
      <Card>
        <CardMedia
          component="img"
          height="140"
          image={banner}
          alt="Banner"
        ></CardMedia>
      </Card>
      <Box
        sx={{
          paddingTop: '8px',
          paddingBottom: '8px',
        }}
      >
        <Typography
          sx={{ flex: 1, color: '#6E6E73' }}
          variant="body2"
          component="p"
        >
          <div dangerouslySetInnerHTML={{ __html: about }}></div>
        </Typography>
      </Box>
    </Box>
  );
}

EventDetails.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventDetails;
